import { Route, Routes } from "react-router-dom";
import { lazyImport } from "@/utils/lazyImport";
import { Auth } from "@/features/authentification";
import { useEffect } from "react";
import { themeStore } from "@/stores/theme";
import { authStore } from "@/stores/authUserTest";
const { Contact } = lazyImport(
  () => import("@/features/contact/index"),
  "Contact"
);

const { Protected } = lazyImport(() => import("./Protected"), "Protected");

export const AppRoutes = () => {
  const { auth } = authStore();
  const { showTheme } = themeStore();

  useEffect(() => {
    document.body.className = !showTheme ? "light " : "dark";
  }, [showTheme]);

  return (
    <Routes>
      {!auth ? (
        <Route path="/*" element={<Auth />} />
      ) : (
        <Route path="/*" element={<Protected />} />
      )}
      <Route path="/contact" element={<Contact />} />
    </Routes>
  );
};
